import { useLocation, useParams } from "react-router-dom";

import { useClimateActionNavigationStore } from "@/domain/climate-action/components/climate-action-quick-navigation/use-climate-action-navigation-store";
import { useProjectNavigationStore } from "@/domain/project/components/project-quick-navigation/use-project-navigation-store";
import { TeamWithoutMembershipList } from "@/domain/team/models/team-model";

import { isOnClimateActionDetailPage } from "./is-on-climate-action-detail-page";
import { isOnProjectDetailPage } from "./is-on-project-detail-page";

export const useTeamNavActiveState = (team: TeamWithoutMembershipList) => {
  const { pathname } = useLocation();
  const { teamId } = useParams();
  const { navigationContext } = useClimateActionNavigationStore();
  const { navigationContext: projectNavigationContext } = useProjectNavigationStore();

  // Only force-active on detail pages — team routes are handled by react-router's natural matching
  const isClimateActionTeamContext =
    isOnClimateActionDetailPage(pathname) && navigationContext?.type === "Team" && navigationContext.id === team.id;
  const isProjectTeamContext =
    isOnProjectDetailPage(pathname) &&
    projectNavigationContext?.type === "Team" &&
    projectNavigationContext.id === team.id;

  return { isClimateActionTeamContext, isProjectTeamContext, teamId };
};
